import { Injector } from '@angular/core';
import { ProjectAlertToasterRequest } from '@finxone-platform/shared/sys-config-types';
import { ActiveProjectInterface } from '../state/project.state';

export class SetActiveProject {
  static readonly type = '[Project] SetActiveProject';
  constructor(public payload: ActiveProjectInterface) {}
}

export class PublishProjectWorkflowConfig {
  static readonly type = '[Project] PublishProjectWorkflowConfig';
  constructor(public payload: { name?: string }, public injector: Injector) {}
}

export class UpdateProjectAlertToaster {
  static readonly type = '[Project] UpdateProjectAlertToaster';
  constructor(public payload: ProjectAlertToasterRequest) {}
}
